import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { PickupDropoffReservation } from '@/types/pickupDropoff';

export const getPickupDropoffReservations = async (
  email: string,
  year: string,
  month: string,
  vehicle_id?: string
): Promise<ApiResult<PickupDropoffReservation[]>> => {
  const searchParams = new URLSearchParams({
    email: email,
    year: year,
    month: month,
  });
  if (vehicle_id) {
    searchParams.append('vehicle_id', vehicle_id);
  }
  const { status, result } = await callApi<PickupDropoffReservation[]>(
    `pickup-dropoff-reservations`,
    'GET',
    searchParams,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
